import { CertificateType } from '@upright/common/model/input/companies/products/ipr';

export enum ExpressionType {
  PureProduct = 'PureProduct',
  Combination = 'Combination',
  ForIndustry = 'ForIndustry',
  Certificate = 'Certificate',
  Recyclability = 'Recyclability',
  UsingEnergySource = 'UsingEnergySource',
  ForSpecialEndUse = 'ForSpecialEndUse',
  ForDisabledPeople = 'ForDisabledPeople',
}

export interface LogicalMixinExpressionBase<T extends ExpressionType> {
  type: T;
}

export interface PureProductExpression extends LogicalMixinExpressionBase<ExpressionType.PureProduct> {
  title: string;
  productCode?: string;
}

export interface CombinationExpression extends LogicalMixinExpressionBase<ExpressionType.Combination> {
  combinations: LogicalMixinExpression[];
}

export interface ForIndustryExpression extends LogicalMixinExpressionBase<ExpressionType.ForIndustry> {
  baseProduct: LogicalMixinExpression;
  forProduct: LogicalMixinExpression;
}

export interface CertificateExpression extends LogicalMixinExpressionBase<ExpressionType.Certificate> {
  baseProduct: LogicalMixinExpression;
  certificate: CertificateType;
}

export interface RecyclabilityExpression extends LogicalMixinExpressionBase<ExpressionType.Recyclability> {
  baseProduct: LogicalMixinExpression;
  recyclability: string;
}

export interface UsingEnergySourceExpression extends LogicalMixinExpressionBase<ExpressionType.UsingEnergySource> {
  baseProduct: LogicalMixinExpression;
  usingEnergySource: LogicalMixinExpression;
}

export interface ForSpecialEndUseExpression extends LogicalMixinExpressionBase<ExpressionType.ForSpecialEndUse> {
  baseProduct: LogicalMixinExpression;
  forSpecialEndUse: LogicalMixinExpression;
}

export interface ForDisabledPeopleExpression extends LogicalMixinExpressionBase<ExpressionType.ForDisabledPeople> {
  baseProduct: LogicalMixinExpression;
}

export type LogicalMixinExpression =
  | PureProductExpression
  | CombinationExpression
  | ForIndustryExpression
  | CertificateExpression
  | RecyclabilityExpression
  | UsingEnergySourceExpression
  | ForSpecialEndUseExpression
  | ForDisabledPeopleExpression;
